import { BrowserRouter } from 'react-router'
import { AppProviders } from './providers/AppProviders'
import { AppRoutes } from './router/routes'

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  )
}
